import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './mock'
import './styles/global.scss'
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(Element);

Vue.config.productionTip = false

// 挂载API服务到Vue原型
Vue.prototype.$api = api

// 在应用启动时恢复区域状态
store.dispatch('region/restoreRegionFromStorage')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
